import React from 'react'
import { Card, Grid, Icon,Image, Popup } from 'semantic-ui-react';
import Progress from 'react-progressbar';
import { dispatch } from '@rematch/core';
import initImage from '../../../../../images/grafix-banner/lifecycledesigner.svg';
import { DateTime } from "luxon";
import EllipsisTooltip from './../../../../common/EllipsisTooltip';
import momentDateAndTime from './../../../../../helpers/momentDateAndTime';
import { history } from '../../../../../helpers'
import noImage from '../../../../../images/common/broken-image.png'
var moment = require('moment');

const dayFlags = [false, true, true, true, true, true, false];
const getWorkingDaysBetween = function (startDate, endDate) {
    if (startDate < endDate) {
        return -1
    }
    let totalWorkingDays = 0;

    while (startDate > endDate) {
        endDate = endDate.plus({ days: 1 });
        const weekDay = endDate.weekday;
        if (dayFlags[weekDay - 1]) {
            totalWorkingDays++;
        }
    }

    return totalWorkingDays;
}
let timer = 0;
let delay = 200;
let prevent = false;
class InitCard extends React.Component {

    handleClick(e, data, index) {
        let thisClick = this;
        timer = setTimeout(function () {
            if (!prevent) {
                thisClick.clickInitiativeCard(e, data, index);
            }
            prevent = false;
        }, delay);
    }

    handleDoubleClick(e, data, index) {
        clearTimeout(timer);
        prevent = true;
        this.doDoubleClickAction(e, data, index);
    }

    doDoubleClickAction(e, data, index) {
        this.clickInitiativeCard(e, data, index);
        dispatch.initiatives.splitAt("60%");
    }

    async clickInitiativeCard(e, data, index) {
        if (this.props.cardData.status === 0) {

            history.push({
                pathname: '/app/' + this.props.routeParams.accountId + '/_ws/' + this.props.routeParams.workspaceId + '/_in/indesign/basicInfo/' + data._id
            });
            await dispatch.initiatives.getInDesignInitiativeDetailsById(data._id);
            dispatch.initiatives.showResourecePane(null);
            dispatch.initiatives.initiativeAggangementPane(null);
        }
        else if (this.props.cardData.status === 1) {
            await dispatch.initiatives.getActiveInitiativeDetailsById(data._id)
            dispatch.initiatives.showResourecePane("ActiveInitiative");
            dispatch.initiatives.initiativeAggangementPane("ActiveInitiativeTabs");
            dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        }
        else if (this.props.cardData.status === 2 || this.props.cardData.status === 3 || this.props.cardData.status === 5 || this.props.cardData.status === -1) {
            await dispatch.initiatives.getActiveInitiativeDetailsById(data._id)
            dispatch.initiatives.showResourecePane("CompletedInitiatives");
            dispatch.initiatives.initiativeAggangementPane("ActiveInitiativeTabs");
            dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        }
        else if (this.props.cardData.status === 4) {

            history.push({
                pathname: '/app/' + this.props.routeParams.accountId + '/_ws/' + this.props.routeParams.workspaceId + '/_in/indesign/teamMapping/' + data._id
            });
            await dispatch.initiatives.getInDesignInitiativeDetailsById(data._id);
            dispatch.initiatives.getTeamMappingData({ organizationId: data.organizationId, initiativeId: data._id, stopProcessing: () => { return false }, teamId: data.teamId });
            dispatch.initiatives.showResourecePane(null);
            dispatch.initiatives.initiativeAggangementPane(null);
        }
        dispatch.initiatives.setSelectedActivityData({});
        dispatch.initiatives.setIdToCenterPosition(data._id);
        dispatch.initiatives.splitAt("60%");
        dispatch.initiatives.setInitiativeError(null);
    }

    addDefaultSrc(ev) {
        ev.target.src = noImage
    }

    render() {
        let currentDate = moment().format('YYYY-MM-DD');
        var initiativeEndDate = moment(this.props.cardData.endDate, "YYYY-MM-DD");
        let isInitiativeEndDelayed = moment.duration(initiativeEndDate.diff(currentDate)).asDays();
        let calProgress = (this.props.cardData.totalCompletedCount / this.props.cardData.totalActivityCount) * 100

        //----------------------------------------------------------
        const workSpaceTimeZone = this.props.cardData.timeZone;
        const asd = DateTime.fromISO(this.props.cardData.actualStartDate).setZone(workSpaceTimeZone).startOf('day');
        const aed = DateTime.fromISO(this.props.cardData.actualEndDate).setZone(workSpaceTimeZone).endOf('day');
        let daysDiffActStartActEnd = getWorkingDaysBetween(aed, asd);

        //------------------------------------------------------------

        let DisplayCard = <Card
            id={this.props.cardData._id}
            className={this.props.cardData._id === this.props.selectedDataById._id && this.props.selectedDataById.status !== 0 ? "packCard activeCard" : "packCard"}
            onClick={(e) => this.handleClick(e, this.props.cardData, this.props.index)}
            onDoubleClick={(e) => this.handleDoubleClick(e, this.props.cardData, this.props.index)}
        >
            <Card.Header><EllipsisTooltip name={this.props.cardData.name} /></Card.Header>
            <Card.Content >
             { (this.props.cardData._id === this.props.selectedDataById._id && this.props.selectedDataById.status !== 0)?
                <Image style={{"filter": "blur(2px)"}} onError={this.addDefaultSrc} className="fitImage" src={this.props.cardData.picture} /> : 
                <Image onError={this.addDefaultSrc} className="fitImage" src={this.props.cardData.picture}/>
            } 
                <Card.Description>
                    {this.props.cardData._id === this.props.selectedDataById._id && this.props.selectedDataById.status !== 0 ?
                        <Grid >
                            <Grid.Row style={{"position":"absolute", "top":"34px","paddingTop": '25px', "paddingBottom": '0',"zIndex":"40"}}>
                                <Grid.Column width={16} style={{ padding: "0 5px" }}>
                                <div className="ui blue circular label cardLabel" style={{ "margin": "5px 0 0 15px","width":'55px' }}>

                                    <Icon name="sitemap" style={{ "margin": "0 10px 0 5px"}} />
                                    <Popup trigger={
                                        <span >
                                            {this.props.selectedDataById.countList && this.props.selectedDataById.countList.activityCount}
                                        </span>
                                    }
                                        content="Activity"
                                        position='top center'
                                        className="popupStyled"
                                        inverted
                                    />
                                    {this.props.cardData.totalIssueCount > 0 ?
                                        <Popup trigger={
                                            <span>
                                                {this.props.cardData.totalIssueCount}
                                            </span>
                                        }
                                            content="Issue"
                                            position='top center'
                                            className="popupStyled"
                                            inverted
                                        /> : null
                                    }
                                    {this.props.cardData.totalDelayedCount > 0 ?
                                        <Popup trigger={
                                            <span>
                                                {this.props.cardData.totalDelayedCount}
                                            </span>
                                        }
                                            content="Delayed"
                                            position='top center'
                                            className="popupStyled"
                                            inverted
                                        /> : null
                                    }
                                </div>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row style={{ "position":"absolute", "top":"85px", "paddingTop": '0', "paddingBottom": '0' }}>
                                {this.props.selectedDataById.status !== -1 && <Grid.Column width={6} style={{ padding: "0 5px" }}>
                                <div className="ui blue circular label cardLabel" style={{ "margin": "5px 0 0 15px","width":'55px' }}>

                                    <Icon name="group" style={{ "margin": "0 10px 0 5px" }} />
                                    <Popup trigger={
                                        <span>
                                            {this.props.selectedDataById.countList && this.props.selectedDataById.countList.userCount}
                                        </span>
                                    }
                                        content="Participant"
                                        position='right center'
                                        className="popupStyled"
                                        inverted
                                    />
                                    </div>
                                </Grid.Column>}
                                {this.props.selectedDataById.status !== -1 && <Grid.Column width={10} style={{ padding: "0 5px" }}>
                                <div className="ui blue circular label cardLabel" style={{ "margin": "5px 0 0 20px","width":'55px' }}>

                                    <Icon name="calendar" style={{ margin: "0 4px" }} />
                                    {/* {this.props.selectedDataById.status === 1 && <span>{this.props.selectedDataById.totaldays} {this.props.selectedDataById.totaldays === 1 ? "day" : "days"} </span>} */}
                                    {/* {this.props.selectedDataById.status === 2 && <span>{daysDiffActStartActEnd === 0 ? 1 : daysDiffActStartActEnd} {daysDiffActStartActEnd === 1 ? "day" : "days"} </span>}
                                    {this.props.selectedDataById.status === 3 && <span>{daysDiffActStartActEnd === 0 ? 1 : daysDiffActStartActEnd} {daysDiffActStartActEnd === 1 ? "day" : "days"}</span>}
                                    {this.props.selectedDataById.status === 5 && <span>{daysDiffActStartActEnd === 0 ? 1 : daysDiffActStartActEnd} {daysDiffActStartActEnd === 1 ? "day" : "days"}</span>} */}
                                    <Popup trigger={
                                        <span style={{margin: "0 0 0 5px" }}>
                                            {this.props.selectedDataById.status === 1 && <span>{this.props.selectedDataById.totaldays} </span>}
                                            {this.props.selectedDataById.status === 2 && <span>{daysDiffActStartActEnd === 0 ? 1 : daysDiffActStartActEnd} </span>}
                                            {this.props.selectedDataById.status === 3 && <span>{daysDiffActStartActEnd === 0 ? 1 : daysDiffActStartActEnd} </span>}
                                            {this.props.selectedDataById.status === 5 && <span>{daysDiffActStartActEnd === 0 ? 1 : daysDiffActStartActEnd} </span>} 
                                        </span>
                                    }
                                        content={daysDiffActStartActEnd === 1 || this.props.selectedDataById.totaldays === 1 ? "day" : "days"}
                                        position='right center'
                                        className="popupStyled"
                                        inverted
                                    />
                                </div>
                                </Grid.Column>}
                            </Grid.Row>
                        </Grid>
                        :
                        <img alt='' onError={this.addDefaultSrc} className="fitImage" src={this.props.cardData.picture ? this.props.cardData.picture : initImage} />
                    }


                    {this.props.cardData.status === 1 && this.props.cardData.totalIssueCount > 0 ?
                        <div className="badge badgeIssue">Issue </div> :
                        this.props.cardData.status === 1 && (isInitiativeEndDelayed) < 0 ?
                            <div className="badge badgeCaution">Delayed </div> :
                            this.props.cardData.status === 1 && this.props.cardData.totalActivityCount !== this.props.cardData.totalCompletedCount
                                && (this.props.cardData.totalInProgressCount > 0 || this.props.cardData.totalCompletedCount > 0) ?
                                <div className="badge badgeOnTrack">In Progress </div> :
                                this.props.cardData.status === 1 && this.props.cardData.totalInProgressCount === 0 ?
                                    <div className="badge badgeNotStarted">Not Started </div> : ""

                    }
                    {this.props.cardData.status === -1 && <div className="badge badgeDraft">Draft </div>}
                    {this.props.cardData.status === 0 && <div className="badge badgeIndesign">In Design </div>}
                    {this.props.cardData.status === 2 && <div className="badge badgeCompleted">Completed </div>}
                    {this.props.cardData.status === 3 && <div className="badge badgeClosed">Closed </div>}
                    {this.props.cardData.status === 4 && <div className="badge badgeInEdit">Editing</div>}
                    {this.props.cardData.status === 5 && <div className="badge badgeCanceled">Cancelled</div>}

                    <div className="badgeRight">
                        {this.props.cardData.status !== 0 &&
                            this.props.cardData.priority !== "NA" && <span
                                className={`badgeblock badgeRightNA
                           ${this.props.cardData.priority === 'Low' ? 'badgeRightLow' : ''} 
                           ${this.props.cardData.priority === 'Medium' ? 'badgeRightMedium' : ''}
                           ${this.props.cardData.priority === 'High' ? 'badgeRightHigh' : ''}
                           `}>
                                {this.props.cardData.priority}
                            </span>}
                    </div>
                </Card.Description>
            </Card.Content>
            {this.props.cardData.status === 1 ?
                <div className="cardProgress progress-active">

                    <Popup
                        trigger={<Progress completed={calProgress ? calProgress : 0} />}
                        content={`${calProgress ? Number(calProgress).toFixed(0) : 0}%`}
                        position="top center"
                        className="popupStyled"
                        inverted
                    />
                </div>
                : ""}
            {this.props.cardData.status === 2 || this.props.cardData.status === 3 || this.props.cardData.status === 5 ?
                <div className="cardProgress progress-completed">
                    <label> {momentDateAndTime(this.props.cardData.actualEndDate ? this.props.cardData.actualEndDate : this.props.cardData.createdAt)} </label>
                    <Progress completed={100} />
                </div>
                : ""}

        </Card>

        return (
            DisplayCard
        )
    }
}

export default InitCard;